import Reflux from 'reflux';

export default Reflux.createActions([
    'onLogin', 'onLogout', 'onViewChange'
]);